import styled from 'styled-components';
import { ConnectFragment } from 'view/common/connect-fragment';
import { sizes } from 'view/styles/sizes-viewport';
import * as mixins from 'view/styles/mixins';
import { token } from '@atlaskit/tokens';

export const StyledConnectFragment = styled(ConnectFragment)`
    margin: auto;
    ${mixins.borderBox};
    margin-top: ${token('space.600', '48px')};
    max-width: ${sizes.small}px;
    padding-left: ${token('space.600', '48px')};
    padding-right: ${token('space.600', '48px')};
    width: 100%;
`;

export const Root = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    margin: auto;
`;
